<template>
  <div class="tc-container">
    <v-card-text class="tc-message pa-0 pb-4">
      <span>{{ $t("page.termsAndConditions.instruction") }}&nbsp;</span>
      <a :href="tcLink" target="_blank">
        <span>{{ $t("page.termsAndConditions.tcTitle") }}&nbsp;</span>
      </a>
      <span>{{ $t("page.termsAndConditions.and") }}&nbsp;</span>
      <a :href="ppLink" target="_blank">
        <span>{{ $t("page.termsAndConditions.ppTitle") }}</span> </a
      >.
    </v-card-text>
    <ValidationObserver ref="obs">
      <BaseCheckbox
        id="agreedTC"
        ref="agreedTC"
        v-model="agreedToTC"
        :checkbox-text="$t('page.termsAndConditions.checkboxMsg')"
        :label="null"
        @updateIndeterminate="onCheckOrUncheck"
      >
      </BaseCheckbox>
    </ValidationObserver>
    <div v-if="invalidForm" class="tc-error-message">
      {{ $t("page.termsAndConditions.errorMsg") }}
    </div>
    <div class="tc-accept-button">
      <base-button
        :title="$t('menu.continue')"
        block
        color="primary"
        data-ruid="button-accept-tc"
        elevation="2"
        @pressed="submitAgreement()"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BaseButton from "../widgets/BaseButton.vue";
import BaseCheckbox from "../core/BaseCheckbox.vue";

@Component({
  name: "TermsAndConditionsForm",
  components: {
    BaseButton,
    BaseCheckbox,
  },
})
export default class TermsAndConditionsForm extends Vue {
  @Prop({ default: null }) readonly tcLink!: string;

  @Prop({ default: null }) readonly ppLink!: string;

  agreedToTC = false;

  invalidForm = false;

  onCheckOrUncheck(value: boolean) {
    this.agreedToTC = value;
    this.invalidForm = !this.agreedToTC;
  }

  async submitAgreement() {
    this.invalidForm = !this.agreedToTC;
    if (this.invalidForm) {
      return;
    }
    this.$emit("onSubmit");
  }
}
</script>

<style lang="scss" scoped>
.tc-container {
  .tc-message {
    color: $secondary_text_color;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }

  .tc-checkbox {
    margin: 0;
    padding: 0;
  }

  .tc-error-message {
    color: $error_color !important;
    padding: 5px 0 10px 0 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    text-align: center;
  }

  .tc-accept-button {
    margin-top: 20px;
  }
}
</style>

<style lang="scss">
.tc-checkbox {
}
</style>
